import {IEvent} from 'matrix-js-sdk';

export const isSportjoeDisplayName = (event: IEvent): boolean => {
  if (
    event.content.displayname === 'Sport Joe' ||
    event.content.displayname === 'SportJoe Admin'
  ) {
    return true;
  } else {
    return false;
  }
};
